import { useCallback, useEffect, useRef, useState } from 'react';
import style from './style.module.scss';
import { joinNames } from '../helpers';
import icons from '../../icons/icons.module.scss';
const LIGHTBOX_STATE_KEY = 'lightbox';

export default function LightBox({
    url,
    icon,
    description,
    nameforuitesting,
    alwaysOpen
}: {
    url?: string;
    icon: JSX.Element;
    description?: JSX.Element;
    nameforuitesting?: string;
    alwaysOpen?: boolean;
}) {
    const dialogRef = useRef<HTMLDialogElement>(null);
    const [open, setOpen] = useState<boolean>();

    const show = useCallback((e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (history.state != LIGHTBOX_STATE_KEY) {
            history.pushState(LIGHTBOX_STATE_KEY, '', '');
        }
        if (dialogRef.current) {
            if ('showModal' in dialogRef.current) {
                dialogRef.current.showModal();
            } else {
                setOpen(true);
            }
        }
    }, []);
    const hide = useCallback((e: React.MouseEvent | React.KeyboardEvent) => {
        if (alwaysOpen) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (dialogRef.current) {
            dialogRef.current.close();
        }        
    }, [alwaysOpen]);

    useEffect(() => {
        const onPopState = () => {
            if (dialogRef.current) {
                if ('showModal' in dialogRef.current) {
                    dialogRef.current.close();
                } else {
                    setOpen(false);
                }
            }
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);
    return url || description ? (
        <>
            <a
                onClick={show}
                data-nameforuitesting={nameforuitesting}
                className={style.clickable}
                tabIndex={0}
                onKeyDown={(e) => ['Enter', 'NumpadEnter'].includes(e.code) && show(e)}
            >
                {icon}
            </a>
            <dialog open={open} className={style.lightbox} onClick={hide} ref={dialogRef}>
                <div className={style.bar}>
                    <div
                        className={joinNames(style.clickable, style.close, style.btnClose, icons.iconClose)}
                        onClick={hide}
                        onKeyDown={(e) => ['Enter', 'NumpadEnter'].includes(e.code) && hide(e)}
                        tabIndex={0}
                    ></div>
                </div>
                {url && (
                    <div className={joinNames(style.imageContainer, style.singleColumn)}>
                        <img src={url} />
                    </div>
                )}
                <div className={joinNames(style.description, style.singleColumn)}>{description}</div>
            </dialog>
        </>
    ) : null;
}
